import { IForm } from 'core-components/classes/models/IForm'
import { IUser } from 'core-components/sitebuilder/models/IUser'
import { Logic, Operator } from 'core-components/types'
import { ICampaign } from 'omnicom/models/ICampaign'
import { IChanges } from 'omnicom/models/IChanges'
import { IChatStore } from 'omnicom/models/IChatStore'
import { IComment } from 'omnicom/models/IComment'
import { IContacts } from 'omnicom/models/IContacts'
import { ICType } from 'omnicom/models/ICType'
import { IEmail } from 'omnicom/models/IEmail'
import { IEmailAction } from 'omnicom/models/IEmailAction'
import { IFormPartners } from 'omnicom/models/IFormPartners'
import { IOmniUser } from 'omnicom/models/IOmniUser'
import { IPdl } from 'omnicom/models/IPdl'
import { IRequest } from 'omnicom/models/IRequest'
import { ISignature } from 'omnicom/models/ISignature'
import { ISlot } from 'omnicom/models/ISlotSettings'
import { ISlotSignUp } from 'omnicom/models/ISlotSignUp'
import { ISummaryStatus } from 'omnicom/models/ISummaryStatus'
import { ITemplate } from 'omnicom/models/ITemplate'
import { ITemplateAttachment } from 'omnicom/models/ITemplateAttachment'
import settings from 'src/config/settings'
import WebSocketStore from 'src/core/classes/services/WebSocketStore'
import { WebSocketClient } from 'src/core/classes/ws/WebSocketClient'
import { Crud } from 'src/core/types/Crud'
import { CrudInnerStorageFetcher } from 'src/core/types/CrudInnerStorageFetcher'
import { CrudStore } from 'src/core/types/crudStore'

export enum CrudStoreItem {
  CampaignInfo = 'CampaignInfo',
  Templates = 'Templates',
  TemplateAttachments = 'TemplateAttachments',
  Contacts = 'Contacts',
  OmniApi = 'OmniApi',
  Comments = 'Comments',
  TemplateChanges = 'TemplateChanges',
  MSACampaigns = 'MSACampaigns',
  MSACampaignSummaryStats = 'MSACampaignSummaryStats',
  MSAEmailActions = 'MSAEmailActions',
  MSAEmails = 'MSAEmails',
  Request = 'Request',
  EmailCampaign = 'EmailCampaign',
  OmniUsers = 'OmniUsers',
  PartnerAllData = 'OmniPartnerAllData',
  ChatStore = 'ChatStore',
  SchedulerSettings = 'SchedulerSettings',
  SchedulerSlots = 'SchedulerSlots',
  SchedulerSlotMarks = 'SchedulerSlotMarks',
  SchedulerSlotSignUp = 'SchedulerSlotSignUp',
  Signature = 'Signature',
  PDLManagment = 'PDLManagment',
  LastOPT = 'LastOPT',
  Translations = 'Translations',
  Survey = 'Survey',
}

class InitializationService {
  public init = (user: IUser) => {
    if (settings.omnicomService && settings.omnicomService.wsServer) {
      const wsClient = new WebSocketClient()
      wsClient.init(settings.omnicomService.wsServer)
      WebSocketStore.add(wsClient, 'omnicom')
    }

    CrudStore.add(
      new Crud<ICampaign>({
        fetcher: new CrudInnerStorageFetcher<ICampaign>('EntryId', {
          formId: 649,
          code: 'OmniCampaignsExt',
        }),
        defaultFilter: {
          logic: Logic.AND,
          filters: [
            {
              field: 'CreatedBy',
              operator: Operator.EQUAL,
              value: user.email,
            },
          ],
        },
        keyField: 'EntryId',
      }),
      CrudStoreItem.CampaignInfo
    )
    CrudStore.add(
      new Crud<IContacts>({
        fetcher: new CrudInnerStorageFetcher<IContacts>('EntryId', {
          formId: 650,
          code: 'MailCampaignPDLContacts',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.Contacts
    )
    CrudStore.add(
      new Crud<ITemplate>({
        fetcher: new CrudInnerStorageFetcher<ITemplate>('EntryId', {
          formId: 651,
          code: 'OmnicomTemplates',
        }),
        defaultSort: {
          field: 'Modified',
          dir: 'desc',
        },
        defaultFilter: {
          logic: Logic.AND,
          filters: [
            {
              operator: Operator.EQUAL,
              field: 'TypeOfProject',
              value: 'Omnicom',
            },
          ],
        },
        keyField: 'EntryId',
      }),
      CrudStoreItem.Templates
    )
    CrudStore.add(
      new Crud<ITemplateAttachment>({
        fetcher: new CrudInnerStorageFetcher<ITemplateAttachment>('EntryId', {
          formId: 990,
          code: 'templateattachments-990',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.TemplateAttachments
    )
    CrudStore.add(
      new Crud<ICType>({
        fetcher: new CrudInnerStorageFetcher<ICType>('CampaignType', {
          formId: 668,
          code: 'OmniCampaignType',
        }),
        keyField: 'CampaignType',
        defaultPaging: {
          page: 0,
          pageSize: 2000,
        },
      }),
      CrudStoreItem.OmniApi
    )
    CrudStore.add(
      new Crud<IComment>({
        fetcher: new CrudInnerStorageFetcher<IComment>('EntryId', {
          formId: 673,
          code: 'OmnicomTemplateComments',
        }),
        keyField: 'EntryId',
        defaultPaging: {
          page: 0,
          pageSize: 2000,
        },
      }),
      CrudStoreItem.Comments
    )
    CrudStore.add(
      new Crud<IChanges>({
        fetcher: new CrudInnerStorageFetcher<IChanges>('Id', {
          formId: 668,
          code: 'LOG_FORM_651',
        }),
        keyField: 'Id',
        defaultPaging: {
          page: 0,
          pageSize: 2000,
        },
        defaultSort: {
          field: 'DateTime',
          dir: 'desc',
        },
      }),
      CrudStoreItem.TemplateChanges
    )
    CrudStore.add(
      new Crud<IForm>({
        fetcher: new CrudInnerStorageFetcher<IForm>('CampaignId', {
          formId: 649,
          code: 'MSACampaigns',
        }),
        keyField: 'CampaignId',
      }),
      CrudStoreItem.MSACampaigns
    )
    CrudStore.add(
      new Crud<ISummaryStatus>({
        fetcher: new CrudInnerStorageFetcher<ISummaryStatus>('CampaignId', {
          formId: 649,
          code: 'MSACampaignSummaryStats',
        }),
        keyField: 'CampaignId',
      }),
      CrudStoreItem.MSACampaignSummaryStats
    )
    CrudStore.add(
      new Crud<IEmailAction>({
        fetcher: new CrudInnerStorageFetcher<IEmailAction>('EntryId', {
          formId: 649,
          code: 'MSAEmailActions',
        }),
        keyField: 'EntryId',
        defaultPaging: {
          page: 0,
          pageSize: 500,
        },
      }),
      CrudStoreItem.MSAEmailActions
    )
    CrudStore.add(
      new Crud<IEmail>({
        fetcher: new CrudInnerStorageFetcher<IEmail>('EntryId', {
          formId: 649,
          code: 'MSAEmails',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.MSAEmails
    )
    CrudStore.add(
      new Crud<IRequest>({
        fetcher: new CrudInnerStorageFetcher<IRequest>('EntryId', {
          formId: 724,
          code: 'OmnicomRequests',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.Request
    )
    CrudStore.add(
      new Crud<ICampaign>({
        fetcher: new CrudInnerStorageFetcher<ICampaign>('EntryId', {
          formId: 649,
          code: 'MailCampaigns',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.EmailCampaign
    )
    CrudStore.add(
      new Crud<IOmniUser>({
        fetcher: new CrudInnerStorageFetcher<IOmniUser>('EntryId', {
          formId: 375,
          code: 'OmniContacts',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.OmniUsers
    )

    CrudStore.add(
      new Crud<IFormPartners>({
        fetcher: new CrudInnerStorageFetcher<IFormPartners>('CommunicationName', {
          formId: 261,
          code: 'PartnerAllDataRegions',
        }),
        keyField: 'CommunicationName',
        defaultPaging: {
          page: 0,
          pageSize: 10,
        },
      }),
      CrudStoreItem.PartnerAllData
    )
    CrudStore.add(
      new Crud<IChatStore>({
        fetcher: new CrudInnerStorageFetcher<IChatStore>('EntryId', {
          formId: 842,
          code: 'chatstore-842',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.ChatStore
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 1053,
          code: 'calendar-settings-1053',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.SchedulerSettings
    )
    CrudStore.add(
      new Crud<ISlot>({
        fetcher: new CrudInnerStorageFetcher<ISlot>('EntryId', {
          formId: 1062,
          code: 'calendar-slots-1062',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.SchedulerSlots
    )
    CrudStore.add(
      new Crud<ISlot>({
        fetcher: new CrudInnerStorageFetcher<ISlot>('EntryId', {
          formId: 1060,
          code: 'calendar-slot-settings-1060',
        }),
        keyField: 'EntryId',
        defaultFilter: {
          logic: Logic.AND,
          filters: [
            {
              field: 'UserId',
              operator: Operator.EQUAL,
              value: user.email,
            },
          ],
        },
      }),
      CrudStoreItem.SchedulerSlotMarks
    )
    CrudStore.add(
      new Crud<ISlotSignUp>({
        fetcher: new CrudInnerStorageFetcher<ISlotSignUp>('EntryId', {
          formId: 1045,
          code: 'calendar-slots-sign-up-1045',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.SchedulerSlotSignUp
    )
    CrudStore.add(
      new Crud<ISignature>({
        fetcher: new CrudInnerStorageFetcher<ISignature>('EntryId', {
          formId: 893,
          code: 'partnerinfo-893',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.Signature
    )
    CrudStore.add(
      new Crud<IPdl>({
        fetcher: new CrudInnerStorageFetcher<IPdl>('EntryId', {
          formId: 650,
          code: 'PDLManagment',
        }),
        defaultFilter: {
          logic: Logic.AND,
          filters: [
            {
              operator: Operator.EQUAL,
              field: 'SPV',
              value: user.email,
            },
          ],
        },
        keyField: 'EntryId',
      }),
      CrudStoreItem.PDLManagment
    )
    CrudStore.add(
      new Crud<IForm>({
        fetcher: new CrudInnerStorageFetcher<IForm>('EntryId', {
          formId: 752,
          code: 'OmnicomUnsubscribe',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.LastOPT
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher<IForm>('EntryId', {
          formId: 1352,
          code: 'translations-1352',
        }),
        keyField: 'EntryId',
        defaultPaging: {
          page: 0,
          pageSize: 200,
        },
      }),
      CrudStoreItem.Translations
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher<IForm>('EntryId', {
          formId: 1341,
          code: 'survey-1341',
        }),
        keyField: 'EntryId',
        defaultPaging: {
          page: 0,
          pageSize: 100,
        },
      }),
      CrudStoreItem.Survey
    )
  }
}

export default new InitializationService()
